import * as yup from 'yup';

import { TWO_TOGGLE_PRICING_TYPES } from '../components/TwoToggleRates';
import { SAFE_PAYMENTS_OPTIONS, WORLDPAY_OPTIONS } from '../sections/CompliancePricing';

const getValidationShape = () => {
    let worldpayProgramme = {};
    let safePayments = {};

    const perItemValidation = yup
        .number()
        .when('type', (type, schema) =>
            type === 'PER_ITEM' ? schema.required() : schema.notRequired()
        );

    SAFE_PAYMENTS_OPTIONS.forEach(({ name }) => {
        safePayments = {
            ...safePayments,
            [name]: yup.object().shape({
                type: yup.string().oneOf(TWO_TOGGLE_PRICING_TYPES.map(({ value }) => value)),
                baseRate: perItemValidation,
                lowestRate: perItemValidation,
                highestRate: perItemValidation,
                fixedRate: yup
                    .number()
                    .when('type', (type, schema) =>
                        type === 'FIXED' ? schema.required() : schema.notRequired()
                    ),
            }),
        };
    });

    WORLDPAY_OPTIONS.forEach(({ name }) => {
        worldpayProgramme = {
            ...worldpayProgramme,
            [name]: yup.object().shape({
                type: yup.string().oneOf(TWO_TOGGLE_PRICING_TYPES.map(({ value }) => value)),
                baseRate: perItemValidation,
                lowestRate: perItemValidation,
                highestRate: perItemValidation,
                fixedRate: yup
                    .number()
                    .when('type', (type, schema) =>
                        type === 'FIXED' ? schema.required() : schema.notRequired()
                    ),
            }),
        };
    });

    return yup.object().shape({
        worldpayProgramme: yup.object().shape(worldpayProgramme),
        safePayments: yup.object().shape(safePayments),
    });
};

export const COMPLIANCE_PRICING_VALIDATION_SCHEMA = {
    compliancePricing: getValidationShape(),
};
